export const SHIPPO_UTM_COOKIE_NAME = 'shippoUTM';
export const SHIPPO_UTM_COOKIE_EXPIRE_DAYS = 30;
export const USER_REGISTER_SUCCESS_COOKIE_NAME = 'user_register_success';
export const STORE_CONNECTION_SUCCESS_COOKIE_NAME = 'store_connection_success';
export const EBAY_CANADA_REGISTRATION_COOKIE_NAME = 'ebay_ca_connect_start';
export const SHIPPO_LASTSEEN_COOKIE_NAME = 'shippo_last_seen';
export const IDENTIFIED_REGISTRATION_USER = 'shippo_identified_registration_user';
export const SEGMENT_ANONYMOUS_COOKIE = 'ajs_anonymous_id';
export const IDENTIFIED_ANONYMOUS_USER = 'shippo_identified_anonymous_user';
